'use strict';

var AlertService = require('./alert-service');
var HTTPService = require('./http-service');
var blzEvent = require('../services/tracking/blz-event');

var NotificationService = {
  success: _notify('success'),
  warning: _notify('warning'),
  error: _notify('danger'),
  info: _notify('info')
};

function _notify(type) {
  return function (notification) {
    var options = {
      type: type,
      timeout: (notification || {}).timeout || 5000,
      msg: HTTPService.parseFirstError(notification)
    };

    AlertService.open(options);

    setTimeout(function () {
      blzEvent.toast(options);
    }, 1);
  };
}

module.exports = NotificationService;
